// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"IncreaseReport_inputContainer__3lEbQ","actionsContainer":"IncreaseReport_actionsContainer__1CzEh"};